/*
 *   File : resource.js
 *   Author : https://evoqins.com
 *   Description : Resource card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';

//Custom component
import { SecondaryButton, TextButton } from '../Buttons';

const ResourceCard = (props) => {

    const navigate = useNavigate();

    // handle navigate course detail
    const _handleNavigateDetail = () => {
        navigate("course-detail", {
            state: {
                course_id: props.course.course_id
            }
        });
    };

    return (
        <div className='e-admin-box-shadow e-border-radius-16 p-3 e-bg-white cursor-pointer'
            onClick={_handleNavigateDetail}>
            <div className='d-flex gap-0-16'>
                <div className='position-relative'>
                    {/* <div className='e-border-radius-8 e-bg-black'> */}
                    <img src={props.course.image}
                        draggable={false}
                        className='e-border-radius-8 '
                        height={154}
                        width={148}
                        alt='course' />
                    {/* </div> */}
                    {/* <span className='top-4px left-4px position-absolute e-bg-spanish-yellow px-3 py-1 e-border-radius-16 left-0 e-alt-font-noto-sans e-text-white e-font-12 e-font-weight-400 line-height-16px'>
                        {props.course.tag}
                    </span> */}
                </div>
                <div className='d-flex flex-column justify-content-between flex-fill'>
                    <div>
                        <h6 className='mb-2 e-primary-font-playfair e-text-charleston-green e-font-16 e-font-weight-600 line-height-22px e-ellipse'>
                            {props.course.title}
                            <span className='text-nowrap ms-1 e-bg-periwinkle px-1 e-border-radius-12 left-0 e-alt-font-noto-sans e-text-raisin-black e-font-10 e-font-weight-400 line-height-16px'>
                                {props.course.category}
                            </span>
                        </h6>
                        <p className='mb-2 e-alt-font-noto-sans e-text-davys-grey e-font-14 e-font-weight-400 line-height-22px e-ellipse-3-line'>
                            {props.course.description}
                        </p>
                        <p className='e-inline-flex mb-0 e-alt-font-noto-sans e-text-davys-grey e-font-12 e-font-weight-500 line-height-14px'>
                            {props.course.no_of_modules} {props.course.no_of_modules === 1 ? 'Section' : 'Sections'}  <span className='ps-2'>{props.course.course_duration}</span>
                        </p>
                    </div>

                    <div className='d-flex align-items-center justify-content-between gap-1'
                        onClick={(e) => e.stopPropagation()}>
                        <TextButton name={props.course.is_disabled === true ? "Enable" : "Disable"}
                            className={props.course.is_disabled === true ? "e-text-philippine-green" : "e-text-lust"}
                            onPress={props.handleDisable} />

                        <div className='d-flex align-items-center gap-0-6px '>
                            <TextButton name="View details"
                                onPress={_handleNavigateDetail} />
                            <SecondaryButton name="Overview"
                                padding="px-1 py-2"
                                className="e-border-1px-indigo e-text-indigo w-84px e-border-radius-6"
                                onPress={() => {
                                    navigate("overview", {
                                        state: {
                                            course_id: props.course.course_id
                                        }
                                    });
                                }} />
                        </div>
                    </div>
                </div>


            </div>

        </div>
    )
}

export default memo(ResourceCard);